import { Link } from "react-router-dom";
import { FaRoad } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="mt-auto w-full bg-navy-950 text-white">
      <div className="mx-auto max-w-6xl px-6 py-12 md:py-14">
        <div className="flex flex-col justify-between gap-10 md:flex-row">
          <div className="max-w-md">
            <div className="mb-3 flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-amber-500 text-navy-950">
                <FaRoad />
              </span>
              <h3 className="font-display text-2xl font-bold">
                Fix<span className="text-amber-400">My</span>Road
              </h3>
            </div>
            <p className="text-white/65">
              Helping communities maintain safer roads through citizen reporting.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3">
            <div>
              <h4 className="mb-3 text-sm font-semibold uppercase tracking-wider text-amber-400">
                Explore
              </h4>
              <ul className="space-y-2 text-white/75">
                <li>
                  <Link to="/report" className="hover:text-amber-300">
                    Report
                  </Link>
                </li>
                <li>
                  <Link to="/potholes" className="hover:text-amber-300">
                    All potholes
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="hover:text-amber-300">
                    About
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="mb-3 text-sm font-semibold uppercase tracking-wider text-amber-400">
                Community
              </h4>
              <ul className="space-y-2 text-white/75">
                <li>
                  <Link to="/feedback" className="hover:text-amber-300">
                    Feedback
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="hover:text-amber-300">
                    Contact
                  </Link>
                </li>
                <li>
                  <Link to="/dashboard" className="hover:text-amber-300">
                    Dashboard
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="mb-3 text-sm font-semibold uppercase tracking-wider text-amber-400">
                Account
              </h4>
              <ul className="space-y-2 text-white/75">
                <li>
                  <Link to="/login" className="hover:text-amber-300">
                    Login
                  </Link>
                </li>
                <li>
                  <Link to="/register" className="hover:text-amber-300">
                    Register
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-10 border-t border-white/10 pt-6 text-sm text-white/50">
          © {new Date().getFullYear()} FixMyRoad. Built for safer streets.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
